<ng-container *ngIf="isLoading">
  <app-loader></app-loader>
</ng-container>

<div class="main-wrapper" *ngIf="!isLoading">
  <router-outlet></router-outlet>
</div>
